import React, { useEffect, useState } from 'react';
import { clearReport, getReport } from '../utils/pageTiming';

// Settings > Performance: how long each page took to load on this device (see utils/pageTiming.js).
// Meant for the lab and for support: look at it, or copy the report and send it.

const SOURCE_LABEL = (sources) => Object.entries(sources || {}).map(([k, v]) => `${v} ${k}`).join(', ') || '-';
const timeOf = (at) => new Date(at).toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

export default function PerformanceCard() {
  const [rows, setRows] = useState(() => getReport());
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const refresh = () => setRows(getReport());
    refresh();
    const timer = window.setInterval(refresh, 2000);
    return () => window.clearInterval(timer);
  }, []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify({ device: navigator.userAgent, taken: new Date().toISOString(), pages: rows }, null, 1));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const shown = rows.slice(-12).reverse();

  return (
    <div className="cardStyle mb-4">
      <div className="cardBody">
        <div className="d-flex align-items-start justify-content-between gap-3">
          <div>
            <h5 className="mb-1">Performance</h5>
            <p className="mb-2" style={{ opacity: 0.7, fontSize: 13 }}>
              How long each page took to load on this device: from opening the page to its last request answering.
              Kept on this device only.
            </p>
          </div>
          <div className="d-flex gap-2 flex-shrink-0">
            <button type="button" className="btn btnLight smBtn" onClick={copy} disabled={rows.length === 0}>{copied ? 'Copied' : 'Copy report'}</button>
            <button type="button" className="btn btnLight smBtn" onClick={() => { clearReport(); setRows(getReport()); }} disabled={rows.length === 0}>Clear</button>
          </div>
        </div>
        {shown.length === 0 ? (
          <p className="mb-0" style={{ opacity: 0.7, fontSize: 13 }}>Nothing recorded yet. Open a few pages and come back.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="table table-sm mb-0" style={{ fontSize: 13 }}>
              <thead>
                <tr><th>Time</th><th>Page</th><th className="text-end">Ready</th><th className="text-end">Requests</th><th>Slowest request</th><th>Answered by</th></tr>
              </thead>
              <tbody>
                {shown.map((r) => (
                  <tr key={`${r.at}-${r.path}`}>
                    <td>{timeOf(r.at)}</td>
                    <td>{r.path}</td>
                    <td className="text-end">{r.readyMs} ms</td>
                    <td className="text-end">{r.calls}{r.laterCalls ? ` (+${r.laterCalls})` : ''}</td>
                    <td>{r.slowest ? `${r.slowest.path.split('/').slice(-2).join('/')} ${r.slowest.ms} ms` : '-'}</td>
                    <td>{SOURCE_LABEL(r.sources)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
